import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { AppProvider } from './context/AppContext'
import { Layout } from './components/layout/Layout'
import { Home } from './pages/Home'
import { Play } from './pages/Play'
import { Stages } from './pages/Stages'
import { Characters } from './pages/Characters'
import { Tournaments } from './pages/Tournaments'
import { Profile } from './pages/Profile'

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/play" element={<Play />} />
            <Route path="/stages" element={<Stages />} />
            <Route path="/characters" element={<Characters />} />
            <Route path="/tournaments" element={<Tournaments />} />
            <Route path="/profile" element={<Profile />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </AppProvider>
  )
}

export default App
